import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/apiClient';
import type { WhatsAppChatListResponse } from '../api/whatsapp';

interface UseChatsParams {
  limit?: number;
  offset?: number;
  unreadOnly?: boolean;
  enabled?: boolean;
}

export function useWhatsAppChats(params: UseChatsParams = {}) {
  const { enabled = true, ...queryParams } = params;

  return useQuery<WhatsAppChatListResponse>({
    queryKey: ['whatsapp', 'chats', queryParams],
    queryFn: async () => {
      const { data } = await api.get<WhatsAppChatListResponse>('/api/whatsapp/chats', { params: queryParams });
      return data;
    },
    enabled,
    staleTime: 1000 * 30, // 30 seconds
  });
}

export function useMarkChatAsRead() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (jid: string) => {
      const { data } = await api.post(`/api/whatsapp/chats/${encodeURIComponent(jid)}/read`);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['whatsapp', 'chats'] });
    },
  });
}
